import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as integrationAutomationResources } from '@atlassian/eoc-integration-automation/resources';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { teamIntegrationListRoute } from '@jira/router-routes__eoc-integration-automation-routes/src/teamIntegrationListRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { IntegrationAutomation } from './ui/IntegrationAutomation.tsx';
import { IntegrationList } from './ui/IntegrationList.tsx';
import { LazyIntegrationAutomation } from './ui/async.tsx';

export const teamIntegrationListRouteEntry: Route = createEntry(teamIntegrationListRoute, () => ({
	group: 'eoc',
	basePath: '/jira/ops/teams',
	// eslint-disable-next-line no-restricted-syntax
	component: IntegrationAutomation,
	layout: opsTeamLayout,
	slot: IntegrationList,

	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		getConsolidationStateResource(),
		integrationAutomationResources.integrationListResource,
		integrationAutomationResources.userAccessRightsResource,
	],

	navigation: {
		menuId: MenuIdPeople,
		horizontal: AsyncHorizontalOperationsNav,
	},

	forPaint: [
		LazyHorizontalOperationsNav,
		LazyAtlassianNavigation,
		LazyIntegrationAutomation,
		LazyTeamDashboardSidebar,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
